import {
  GET_CONTENT_SERIES_START,
  GET_CONTENT_SERIES_SUCCESS,
  GET_CONTENT_SERIES_ERROR,
} from 'actions/content';

const initialState = {
  inProgress: false,
  success: false,
  error: null,
  data: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_CONTENT_SERIES_START: {
      return {
        inProgress: true,
        success: null,
        error: null,
        data: null,
      };
    }
    case GET_CONTENT_SERIES_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case GET_CONTENT_SERIES_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    default: {
      return state;
    }
  }
}
